export function StringToSVGElement(source: string): SVGElement {
  // Create a non-visible node to render the SVG string
  const SVGContainer = document.createElement('div')
  SVGContainer.style.display = 'none'
  SVGContainer.innerHTML = source
  const svgNode = SVGContainer.firstElementChild as SVGElement

  return svgNode
}

export function SVGToBase64(el: SVGElement): string {
  const svgXml = new XMLSerializer().serializeToString(el)
  const svgBase64 = 'data:image/svg+xml;base64,' + btoa(svgXml)
  return svgBase64
}

/**
 * Simple function that converts a plain SVG string or SVG DOM Node into an image with custom dimensions.
 *
 * @param {Object} settings The configuration object to override the default settings.
 * @see https://ourcodeworld.com/articles/read/1456/how-to-convert-a-plain-svg-string-or-svg-node-to-an-image-png-or-jpeg-in-the-browser-with-javascript
 * @returns {Promise}
 */
export function SVGToImage(
  svg: string | SVGElement,
  outputFormat: 'base64' | 'blob'
): Promise<Blob | string | null> {
  const settings = {
    svg: svg,
    // Usually all SVG have transparency, so PNG is the way to go by default
    mimetype: 'image/png',
    quality: 0.92,
    width: 'auto',
    height: 'auto',
    outputFormat: outputFormat,
  }

  return new Promise(function(resolve, reject) {
    let svgNode: SVGElement

    // Create SVG Node if a plain string has been provided
    if (typeof settings.svg == 'string') {
      svgNode = StringToSVGElement(settings.svg)
    } else {
      svgNode = settings.svg
    }

    const canvas = document.createElement('canvas')
    const context = canvas.getContext('2d')

    const svgBase64 = SVGToBase64(svgNode)

    const image = new Image()

    image.onload = function<HTMLImageElement>() {
      let finalWidth, finalHeight

      // Calculate width if set to auto and the height is specified (to preserve aspect ratio)
      if (settings.width === 'auto' && settings.height !== 'auto') {
        finalWidth = (this.width / this.height) * parseFloat(settings.height)
        // Use image original width
      } else if (settings.width === 'auto') {
        finalWidth = this.naturalWidth
        // Use custom width
      } else {
        finalWidth = settings.width
      }

      // Calculate height if set to auto and the width is specified (to preserve aspect ratio)
      if (settings.height === 'auto' && settings.width !== 'auto') {
        finalHeight = (this.height / this.width) * parseFloat(settings.width)
        // Use image original height
      } else if (settings.height === 'auto') {
        finalHeight = this.naturalHeight
        // Use custom height
      } else {
        finalHeight = settings.height
      }

      // Define the canvas intrinsic size
      canvas.width = finalWidth as number
      canvas.height = finalHeight as number

      // Render image in the canvas
      ;(context as any).drawImage(this, 0, 0, finalWidth, finalHeight)

      if (settings.outputFormat == 'blob') {
        // Fullfil and Return the Blob image
        canvas.toBlob(
          function(blob) {
            resolve(blob)
          },
          settings.mimetype,
          settings.quality
        )
      } else {
        // Fullfil and Return the Base64 image
        resolve(canvas.toDataURL(settings.mimetype, settings.quality))
      }
    }

    // Load the SVG in Base64 to the image
    image.src = svgBase64
  })
}
